import React, { useState, useEffect, forwardRef } from 'react';

const withHydrationSafeWrapper = (Component) => {
  const WrappedComponent = forwardRef((props, ref) => {
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
      setIsMounted(true);
    }, []);

    if (!isMounted) {
      return <div suppressHydrationWarning />;
    }

    return <Component {...props} ref={ref} />;
  });

  WrappedComponent.displayName = `HydrationSafe(${Component.displayName || Component.name || 'Component'})`;

  return WrappedComponent;
};

export default withHydrationSafeWrapper;
